import { render, staticRenderFns } from "./ads-popup.vue?vue&type=template&id=62b73faa&"
import script from "./ads-popup.vue?vue&type=script&lang=js&"
export * from "./ads-popup.vue?vue&type=script&lang=js&"
import style0 from "./ads-popup.vue?vue&type=style&index=0&id=62b73faa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports